import { useState, useEffect } from "react";
import "@/App.css";
import { Phone, MapPin, Clock, ChevronDown, Menu, X, Mail } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "./components/ui/tabs";

// Menu Data
const menuData = {
  desayunos: {
    title: "Desayunos",
    subtitle: "Desde las 7:00 am",
    sections: [
      {
        name: "Panes",
        description: "Elige el pan que más te guste y los productos para untar: Tomate, salmorejo, AOVE, mantequilla, mermelada o paté.",
        items: [
          { name: "Viena (Entera)", price: "1,70€" },
          { name: "Mollete de Espera (Pequeño)", price: "1,70€" },
          { name: "Mollete de Espera (Grande)", price: "2,00€" },
          { name: "Cereales (Entera)", price: "1,70€" },
          { name: "Sin gluten (Entera)", price: "2,20€" },
        ]
      },
      {
        name: "Ingredientes Extra",
        items: [
          { name: "Jamón ibérico", price: "1,10€ / 1,60€", description: "Pequeño / Grande" },
          { name: "Panceta ibérica", price: "0,60€ / 0,90€", description: "Pequeño / Grande" },
          { name: "Chicharrón de Cádiz", price: "0,70€ / 0,90€", description: "Pequeño / Grande" },
          { name: "Carne mechada", price: "1,00€ / 1,20€", description: "Pequeño / Grande" },
          { name: "Queso fresco o crema", price: "0,60€ / 0,80€", description: "Pequeño / Grande" },
          { name: "Aguacate", price: "0,70€ / 1,00€", description: "Pequeño / Grande" },
        ]
      },
      {
        name: "Especiales",
        items: [
          { name: "Huevos revueltos", price: "3,00€" },
          { name: "Tortilla francesa", price: "3,00€" },
          { name: "Sandwich mixto", price: "4,00€" },
          { name: "Croissant", price: "2,50€" },
          { name: "Croissant york y queso", price: "4,00€" },
          { name: "Croissant vegetal", price: "4,50€", description: "Tomate, atún, lechuga, huevo duro" },
        ]
      },
      {
        name: "Café e Infusiones",
        items: [
          { name: "Café con leche", price: "1,50€" },
          { name: "Capuccino", price: "1,80€" },
          { name: "Café irlandés", price: "4,50€" },
          { name: "Infusiones", price: "1,50€" },
          { name: "Zumo de naranja natural", price: "2,50€" },
        ]
      }
    ]
  },
  tapas: {
    title: "Tapas & Raciones",
    subtitle: "El auténtico sabor gaditano",
    sections: [
      {
        name: "Platos del Día",
        items: [
          { name: "Guiso o plato del día", price: "3,50€ / 7,00€", description: "Tapa / Ración" },
          { name: "Ensaladilla de langostinos", price: "3,50€ / 8,00€", description: "Tapa / Ración" },
          { name: "Salmorejo", price: "5,00€", description: "Ración" },
          { name: "Patatas aliñadas", price: "3,50€ / 8,00€", description: "Tapa / Ración" },
          { name: "Huevos fritos con jamón ibérico", price: "9,50€", description: "Con patatas fritas" },
        ]
      },
      {
        name: "Especialidades",
        items: [
          { name: "Rabo de toro", price: "20,00€", description: "Ración" },
          { name: "Habas baby con jamón", price: "15,00€", description: "Con huevos" },
          { name: "Tomate de temporada con melva", price: "10,50€", description: "Ración" },
          { name: "Panceta ibérica", price: "4,50€ / 8,00€", description: "Tapa / Ración" },
          { name: "Chicharrones de Cádiz", price: "4,50€ / 8,00€", description: "Tapa / Ración" },
          { name: "Carne mechada", price: "4,50€ / 8,00€", description: "Tapa / Ración" },
        ]
      },
      {
        name: "Ibéricos y Quesos",
        items: [
          { name: "Jamón ibérico", price: "11,00€ / 17,00€", description: "Tapa / Ración" },
          { name: "Queso manchego", price: "7,00€ / 12,50€", description: "Tapa / Ración" },
          { name: "Tabla de ibéricos", price: "11,00€ / 17,00€", description: "Chorizo, salchichón, caña de lomo, jamón" },
          { name: "Tabla de ahumados", price: "7,50€ / 12,50€", description: "Tapa / Ración" },
        ]
      },
      {
        name: "Tostas",
        items: [
          { name: "Jamón ibérico con AOVE", price: "7,00€" },
          { name: "Jamón ibérico con salmorejo", price: "7,00€" },
          { name: "Queso ahumado con cebolla", price: "7,00€", description: "Con salsa baronceli" },
          { name: "Chicharrones de Cádiz", price: "7,00€" },
        ]
      },
      {
        name: "Para Picar",
        items: [
          { name: "Anchoas del cantábrico 00", price: "3,00€", description: "Unidad" },
          { name: "Gilda", price: "3,50€", description: "Unidad" },
          { name: "Picadillo", price: "3,50€ / 8,00€", description: "Tapa / Ración" },
        ]
      }
    ]
  },
  bebidas: {
    title: "Bebidas",
    subtitle: "Cervezas, vinos y más",
    sections: [
      {
        name: "Cervezas y Aperitivos",
        items: [
          { name: "Cruzcampo de barril (cortada)", price: "1,90€" },
          { name: "Cruzcampo de barril (entera)", price: "3,00€" },
          { name: "Cruzcampo sin alcohol / Tercio", price: "2,20€" },
          { name: "Cruzcampo quinto", price: "1,50€" },
          { name: "Vermouth (blanco o rojo)", price: "4,00€" },
          { name: "Tinto con casera", price: "2,50€" },
        ]
      },
      {
        name: "Vinos Blancos",
        items: [
          { name: "Beronia Verdejo", price: "3,50€", description: "Copa" },
          { name: "Javier Sanz Semidulce", price: "3,50€", description: "Copa" },
          { name: "Croft Twist", price: "3,50€", description: "Copa" },
        ]
      },
      {
        name: "Vinos Tintos",
        items: [
          { name: "Beronia Edición Limitada", price: "3,50€ / 18€", description: "Copa / Botella" },
          { name: "Finca Resalso Emilio Moro", price: "3,50€ / 18€", description: "Copa / Botella" },
          { name: "Beronia Reserva", price: "24€", description: "Botella" },
          { name: "Finca Moncloa", price: "24€", description: "Botella" },
        ]
      },
      {
        name: "Vinos Generosos",
        items: [
          { name: "Tío Pepe", price: "3,50€ / 17€", description: "Copa / Botella" },
          { name: "Manzanilla Gabriela", price: "3,50€ / 17€", description: "Copa / Botella" },
          { name: "Oloroso Solera 1847", price: "3,50€ / 17€", description: "Copa / Botella" },
          { name: "Amontillado", price: "4,00€ / 18€", description: "Copa / Botella" },
          { name: "Palo Cortado", price: "5,50€", description: "Copa" },
        ]
      },
      {
        name: "Refrescos y Licores",
        items: [
          { name: "Coca-Cola, Fanta, zumos", price: "2,00€" },
          { name: "Aquarius, Monster", price: "2,50€" },
          { name: "Anís, Ponche, Brandy Terry", price: "2,00€" },
          { name: "Brandy Magno", price: "3,00€" },
          { name: "Combinado Normal", price: "6,00€" },
          { name: "Combinado Premium", price: "6,50€" },
        ]
      }
    ]
  }
};

// Real images from the tavern
const IMAGES = {
  logo: "https://customer-assets.emergentagent.com/job_elquite-portal/artifacts/8klpfq5p_LOGO%20EL%20QUITE.png",
  contrabarra: "https://customer-assets.emergentagent.com/job_elquite-portal/artifacts/b7jytmj4_CONTRABARRA%20.jpeg",
  contrabarra2: "https://customer-assets.emergentagent.com/job_elquite-portal/artifacts/w1p6o0i1_contrabarra%202.jpeg",
  cuadros: "https://customer-assets.emergentagent.com/job_elquite-portal/artifacts/66nfu0vg_CUADROS%20PARED.jpeg",
  comida: "https://customer-assets.emergentagent.com/job_elquite-portal/artifacts/csnp2axc_foto%20mesa%20con%20comida.png",
  mesa: "https://customer-assets.emergentagent.com/job_elquite-portal/artifacts/5ksc2d4k_mesa%20.jpeg",
};

// Promo images
const PROMOS = {
  tapear: "https://customer-assets.emergentagent.com/job_elquite-portal/artifacts/t8az0kbz_promo%20ven%20a%20tapear.png",
  brunch: "https://customer-assets.emergentagent.com/job_elquite-portal/artifacts/ux7yi9s9_Prueba%20nuestro%20brunch.png",
  desayunos: "https://customer-assets.emergentagent.com/job_elquite-portal/artifacts/89pnhdo1_A5%20FLYER%20EL%20QUITE%20DESAYUNOS%20.png",
};

// Navigation Component
const Navigation = ({ activeSection, mobileMenuOpen, setMobileMenuOpen }) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { id: 'inicio', label: 'Inicio' },
    { id: 'carta', label: 'Carta' },
    { id: 'nosotros', label: 'Nosotros' },
    { id: 'contacto', label: 'Contacto' },
  ];

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  return (
    <nav 
      data-testid="main-navigation"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled 
          ? 'bg-tavern-cream/95 backdrop-blur-md shadow-md' 
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <button 
            onClick={() => scrollToSection('inicio')}
            className="flex items-center gap-3 group"
            data-testid="logo-button"
          >
            <img 
              src={IMAGES.logo} 
              alt="Taberna El Quite" 
              className={`h-12 w-auto transition-all ${scrolled ? 'brightness-100' : 'brightness-0 invert'}`}
            />
          </button>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollToSection(link.id)}
                data-testid={`nav-${link.id}`}
                className={`nav-link font-sans text-sm uppercase tracking-widest transition-colors ${
                  scrolled 
                    ? 'text-tavern-charcoal hover:text-tavern-red' 
                    : 'text-white/90 hover:text-white'
                } ${activeSection === link.id ? 'active' : ''}`}
              >
                {link.label}
              </button>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-button"
            className={`md:hidden p-2 ${scrolled ? 'text-tavern-charcoal' : 'text-white'}`}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div 
          data-testid="mobile-menu"
          className="md:hidden bg-tavern-cream/98 backdrop-blur-md border-t border-tavern-red/10"
        >
          <div className="px-4 py-6 space-y-4">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollToSection(link.id)}
                data-testid={`mobile-nav-${link.id}`}
                className="block w-full text-left font-sans text-lg text-tavern-charcoal hover:text-tavern-red py-2 border-b border-tavern-red/10"
              >
                {link.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
};

// Hero Section
const HeroSection = () => {
  const scrollToMenu = () => {
    document.getElementById('carta')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section 
      id="inicio" 
      data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={IMAGES.contrabarra}
          alt="Taberna El Quite"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 hero-gradient"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 max-w-4xl mx-auto">
        <img 
          src={IMAGES.logo} 
          alt="Taberna El Quite" 
          className="h-32 sm:h-40 lg:h-48 w-auto mx-auto mb-6 animate-fade-in stagger-1 brightness-0 invert"
        />
        <p className="font-sans text-lg sm:text-xl text-white/80 mb-4 max-w-2xl mx-auto animate-fade-in-up stagger-3">
          Taberna gaditana especializada en desayunos y tapeo
        </p>
        <div className="gold-line mx-auto mb-8 animate-fade-in stagger-3"></div>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in-up stagger-4">
          <button
            onClick={scrollToMenu}
            data-testid="hero-menu-button"
            className="btn-shine bg-tavern-red text-white hover:bg-tavern-wood transition-colors duration-300 rounded-sm px-8 py-4 font-serif tracking-wide shadow-lg hover:shadow-xl"
          >
            Ver Carta
          </button>
          <a
            href="tel:956472548"
            data-testid="hero-phone-button"
            className="border-2 border-white/60 text-white hover:bg-white/10 transition-colors duration-300 rounded-sm px-8 py-4 font-serif tracking-wide flex items-center gap-2"
          >
            <Phone size={18} />
            956 472 548
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <ChevronDown className="text-white/60" size={32} />
      </div>
    </section>
  );
};

// Promos Section
const PromosSection = () => {
  return (
    <section 
      data-testid="promos-section"
      className="py-16 lg:py-24 bg-tavern-paper"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="font-sans text-sm uppercase tracking-[0.2em] text-tavern-gold">
            Ofertas Especiales
          </span>
          <h2 className="font-serif text-4xl sm:text-5xl font-bold text-tavern-charcoal mt-4 mb-6">
            Nuestras Promos
          </h2>
          <div className="section-divider"></div>
        </div>

        {/* Promo Cards */}
        <div className="grid md:grid-cols-2 gap-6 lg:gap-8 max-w-4xl mx-auto">
          {/* Desayunos */}
          <div className="image-hover rounded-sm overflow-hidden shadow-xl group">
            <img
              src={PROMOS.desayunos}
              alt="Ven a desayunar - Tu nuevo lugar de encuentro en Bahía Blanca"
              className="w-full h-auto object-cover"
              data-testid="promo-desayunos"
            />
          </div>

          {/* Ven a Tapear */}
          <div className="image-hover rounded-sm overflow-hidden shadow-xl group">
            <img
              src={PROMOS.tapear}
              alt="Ven a tapear - Tu rincón de tapas en Bahía Blanca"
              className="w-full h-auto object-cover"
              data-testid="promo-tapear"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

// Menu Section
const MenuSection = () => {
  return (
    <section 
      id="carta" 
      data-testid="menu-section"
      className="py-20 lg:py-32 bg-tavern-cream relative grain-overlay"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="font-sans text-sm uppercase tracking-[0.2em] text-tavern-gold">
            Nuestra Carta
          </span>
          <h2 className="font-serif text-4xl sm:text-5xl font-bold text-tavern-charcoal mt-4 mb-6">
            Sabores de Cádiz
          </h2>
          <div className="section-divider"></div>
          <p className="font-sans text-tavern-charcoal/70 mt-6 max-w-2xl mx-auto">
            Tradición gaditana en cada plato. Desayunos desde las 7:00 y tapeo durante todo el día.
          </p>
        </div>

        {/* Menu Tabs */}
        <Tabs defaultValue="desayunos" className="w-full">
          <TabsList 
            data-testid="menu-tabs"
            className="w-full flex justify-center gap-2 sm:gap-4 bg-transparent mb-12 flex-wrap"
          >
            <TabsTrigger 
              value="desayunos"
              data-testid="tab-desayunos"
              className="font-serif text-base sm:text-lg px-6 py-3 rounded-sm border-2 border-transparent data-[state=active]:border-tavern-red data-[state=active]:bg-tavern-red data-[state=active]:text-white transition-all"
            >
              Desayunos
            </TabsTrigger>
            <TabsTrigger 
              value="tapas"
              data-testid="tab-tapas"
              className="font-serif text-base sm:text-lg px-6 py-3 rounded-sm border-2 border-transparent data-[state=active]:border-tavern-red data-[state=active]:bg-tavern-red data-[state=active]:text-white transition-all"
            >
              Tapas & Raciones
            </TabsTrigger>
            <TabsTrigger 
              value="bebidas"
              data-testid="tab-bebidas"
              className="font-serif text-base sm:text-lg px-6 py-3 rounded-sm border-2 border-transparent data-[state=active]:border-tavern-red data-[state=active]:bg-tavern-red data-[state=active]:text-white transition-all"
            >
              Bebidas
            </TabsTrigger>
          </TabsList>

          {Object.entries(menuData).map(([key, category]) => (
            <TabsContent 
              key={key} 
              value={key}
              data-testid={`menu-content-${key}`}
              className="mt-0"
            >
              <div className="text-center mb-10">
                <h3 className="font-serif text-2xl font-bold text-tavern-charcoal">
                  {category.title}
                </h3>
                <p className="font-sans text-sm text-tavern-charcoal/60 mt-2">
                  {category.subtitle}
                </p>
              </div>

              <div className="space-y-12">
                {category.sections.map((section, sectionIndex) => (
                  <div key={sectionIndex} className="paper-texture rounded-sm p-6 sm:p-8">
                    <h4 className="font-serif text-xl font-bold text-tavern-red mb-2">
                      {section.name}
                    </h4>
                    {section.description && (
                      <p className="font-sans text-sm text-tavern-charcoal/60 mb-6 italic">
                        {section.description}
                      </p>
                    )}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {section.items.map((item, itemIndex) => (
                        <div 
                          key={itemIndex}
                          className="menu-card bg-white p-4 border border-tavern-paper flex justify-between items-start gap-4"
                        >
                          <div className="flex-1">
                            <span className="font-sans font-medium text-tavern-charcoal">
                              {item.name}
                            </span>
                            {item.description && (
                              <p className="font-sans text-xs text-tavern-charcoal/50 mt-1">
                                {item.description}
                              </p>
                            )}
                          </div>
                          <span className="price-tag text-base whitespace-nowrap">
                            {item.price}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>

              <p className="text-center font-sans text-xs text-tavern-charcoal/40 mt-8">
                Precios en € impuestos incluidos · Pan y picos 1€ / Picos 0,50€
              </p>
            </TabsContent>
          ))}
        </Tabs>
      </div>
    </section>
  );
};

// About Section
const AboutSection = () => {
  return (
    <section 
      id="nosotros" 
      data-testid="about-section"
      className="py-20 lg:py-32 bg-tavern-paper"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image Grid */}
          <div className="grid grid-cols-2 gap-4">
            <div className="image-hover rounded-sm overflow-hidden shadow-xl col-span-2">
              <img
                src={IMAGES.comida}
                alt="Tapas en Taberna El Quite"
                className="w-full h-[250px] object-cover"
              />
            </div>
            <div className="image-hover rounded-sm overflow-hidden shadow-lg">
              <img
                src={IMAGES.mesa}
                alt="Interior de Taberna El Quite"
                className="w-full h-[180px] object-cover"
              />
            </div>
            <div className="image-hover rounded-sm overflow-hidden shadow-lg">
              <img
                src={IMAGES.cuadros}
                alt="Decoración Taberna El Quite"
                className="w-full h-[180px] object-cover"
              />
            </div>
          </div>

          {/* Content */}
          <div>
            <span className="font-sans text-sm uppercase tracking-[0.2em] text-tavern-gold">
              Sobre Nosotros
            </span>
            <h2 className="font-serif text-4xl sm:text-5xl font-bold text-tavern-charcoal mt-4 mb-8">
              De Cádiz a tu mesa
            </h2>
            <div className="gold-line mb-8"></div>
            <div className="space-y-6 font-sans text-tavern-charcoal/80 leading-relaxed">
              <p>
                En el corazón de Cádiz, <strong className="text-tavern-red">Taberna El Quite</strong> es 
                un rincón donde el tiempo parece detenerse entre el aroma del café recién hecho 
                y el sabor de las tapas de siempre.
              </p>
              <p>
                Desde primera hora de la mañana servimos desayunos tradicionales: 
                tostadas con tomate y aceite, molletes de Espera, chicharrones de Cádiz... 
                Todo lo que hace especial un desayuno gaditano.
              </p>
              <p>
                Al mediodía y por la tarde, nuestras tapas y raciones mantienen viva 
                la esencia del tapeo andaluz. Jamón ibérico, patatas aliñadas, carne mechada, 
                y nuestro famoso <em>rabo de toro</em>.
              </p>
            </div>

            {/* Features */}
            <div className="grid grid-cols-2 gap-6 mt-10">
              <div className="border-l-4 border-tavern-gold pl-4">
                <span className="font-serif text-3xl font-bold text-tavern-red">7:00</span>
                <p className="font-sans text-sm text-tavern-charcoal/60 mt-1">
                  Apertura diaria
                </p>
              </div>
              <div className="border-l-4 border-tavern-gold pl-4">
                <span className="font-serif text-3xl font-bold text-tavern-red">100%</span>
                <p className="font-sans text-sm text-tavern-charcoal/60 mt-1">
                  Producto local
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Contact Section
const ContactSection = () => {
  return (
    <section 
      id="contacto" 
      data-testid="contact-section"
      className="py-20 lg:py-32 bg-tavern-cream relative grain-overlay"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="font-sans text-sm uppercase tracking-[0.2em] text-tavern-gold">
            Visítanos
          </span>
          <h2 className="font-serif text-4xl sm:text-5xl font-bold text-tavern-charcoal mt-4 mb-6">
            Dónde Encontrarnos
          </h2>
          <div className="section-divider"></div>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-start">
          {/* Contact Info */}
          <div className="space-y-8">
            {/* Phone - Prominent */}
            <div className="paper-texture p-8 rounded-sm text-center">
              <Phone className="w-10 h-10 text-tavern-red mx-auto mb-4" />
              <p className="font-sans text-sm uppercase tracking-widest text-tavern-charcoal/60 mb-2">
                Llámanos
              </p>
              <a 
                href="tel:956472548"
                data-testid="contact-phone"
                className="font-serif text-3xl sm:text-4xl font-bold text-tavern-red hover:text-tavern-wood transition-colors phone-highlight"
              >
                956 472 548
              </a>
              <p className="font-sans text-sm text-tavern-charcoal/50 mt-4">
                No aceptamos reservas · Ven a visitarnos
              </p>
            </div>

            {/* Address & Hours & Email */}
            <div className="grid sm:grid-cols-3 gap-6">
              <div className="bg-white p-6 rounded-sm border border-tavern-paper">
                <MapPin className="w-8 h-8 text-tavern-gold mb-4" />
                <h4 className="font-serif text-lg font-bold text-tavern-charcoal mb-2">
                  Dirección
                </h4>
                <p className="font-sans text-tavern-charcoal/70" data-testid="contact-address">
                  Calle Acacias 8<br />
                  11008 Cádiz
                </p>
              </div>
              <div className="bg-white p-6 rounded-sm border border-tavern-paper">
                <Clock className="w-8 h-8 text-tavern-gold mb-4" />
                <h4 className="font-serif text-lg font-bold text-tavern-charcoal mb-2">
                  Horario
                </h4>
                <p className="font-sans text-tavern-charcoal/70" data-testid="contact-hours">
                  Lun - Jue: 8:00 - 16:30 y 19:00 - 22:00<br />
                  Viernes: 8:00 - 24:00<br />
                  Sábado: 8:00 - 24:00<br />
                  <span className="text-tavern-red font-medium">Domingo: Cerrado</span><br />
                  <span className="text-tavern-gold font-medium">🌿 Dom 29 Mar (Domingo de Ramos): 10:00 - 01:30</span>
                </p>
              </div>
              <div className="bg-white p-6 rounded-sm border border-tavern-paper">
                <Mail className="w-8 h-8 text-tavern-gold mb-4" />
                <h4 className="font-serif text-lg font-bold text-tavern-charcoal mb-2">
                  Email
                </h4>
                <a 
                  href="mailto:info@tabernaelquite.es"
                  data-testid="contact-email"
                  className="font-sans text-tavern-red hover:text-tavern-charcoal transition-colors"
                >
                  info@tabernaelquite.es
                </a>
              </div>
            </div>
          </div>

          {/* Map */}
          <div className="map-container rounded-sm overflow-hidden h-[400px]">
            <iframe
              title="Ubicación de Taberna El Quite"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3209.3!2d-6.2915!3d36.5295!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd0dd2178a8b9a9f%3A0x1!2sCalle%20Acacias%2C%208%2C%2011008%20C%C3%A1diz!5e0!3m2!1ses!2ses!4v1"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              data-testid="contact-map"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

// Footer
const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer 
      data-testid="footer"
      className="footer-pattern py-12 text-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Logo & Tagline */}
          <div className="text-center md:text-left">
            <img 
              src={IMAGES.logo} 
              alt="Taberna El Quite" 
              className="h-16 w-auto mx-auto md:mx-0 brightness-0 invert opacity-80"
            />
            <p className="font-sans text-sm text-white/60 mt-3">
              Cádiz · Desayunos y Tapeo
            </p>
          </div>

          {/* Contact Quick */}
          <div className="flex flex-col sm:flex-row items-center gap-6 text-center">
            <div>
              <p className="font-sans text-xs uppercase tracking-widest text-white/40 mb-1">
                Teléfono
              </p>
              <a 
                href="tel:956472548" 
                className="font-serif text-lg text-tavern-gold hover:text-white transition-colors"
              >
                956 472 548
              </a>
            </div>
            <div className="hidden sm:block w-px h-8 bg-white/20"></div>
            <div>
              <p className="font-sans text-xs uppercase tracking-widest text-white/40 mb-1">
                Dirección
              </p>
              <p className="font-sans text-white/80">
                C/ Acacias 8, 11008 Cádiz
              </p>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-10 pt-6 border-t border-white/10 text-center">
          <p className="font-sans text-xs text-white/40">
            © {currentYear} Taberna El Quite. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

// Main App
function App() {
  const [activeSection, setActiveSection] = useState('inicio');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['inicio', 'carta', 'nosotros', 'contacto'];
      const scrollPosition = window.scrollY + 100;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const offsetTop = element.offsetTop;
          const offsetHeight = element.offsetHeight;

          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="App" data-testid="app-container">
      <Navigation 
        activeSection={activeSection} 
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
      />
      <main>
        <HeroSection />
        <PromosSection />
        <MenuSection />
        <AboutSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
